import { getTimelineElements } from "@Api/getTimelineElements";
export const EMPTY_TIMELINE_ERROR = "empty-timeline";
const END_ENTRY_PREFIX = "end-";
const decodeHtmlEntities = (value)=>{
    if (typeof DOMParser === "undefined") {
        return value;
    }
    const parser = new DOMParser();
    let decoded = value;
    // Multiple passes handle double-encoded values such as "&amp;oslash;".
    for(let i = 0; i < 3; i += 1){
        const next = parser.parseFromString(decoded, "text/html").documentElement.textContent ?? "";
        if (next === decoded) {
            break;
        }
        decoded = next;
    }
    return decoded;
};
// HTML cleaning utility function
const cleanHtml = (htmlString)=>{
    if (!htmlString) return "";
    const decoded = decodeHtmlEntities(htmlString);
    const withoutTags = decoded.replace(/<[^>]*>/g, " ");
    // Clean up extra whitespace
    return withoutTags.replace(/\u00a0/g, " ").replace(/\s+/g, " ").trim();
};
const formatDate = (date, locale)=>date ? new Date(date).toLocaleDateString(locale, {
        year: "numeric",
        month: "long",
        day: "numeric",
        timeZone: "UTC"
    }) : "";
const byDate = (a, b)=>{
    if (!a.data.date || !b.data.date) return Number(!a.data.date) - Number(!b.data.date);
    return a.data.date.localeCompare(b.data.date);
};
export const insertTimeline = async ({ token, id, headers, locale })=>{
    if (!id) {
        throw new Error("Timeline ID is required");
    }
    const res = await getTimelineElements(token, id);
    const nodes = res.data.elements.nodes.filter((node)=>node.type === "horizontal" && !node.data.id.startsWith(END_ENTRY_PREFIX)).sort(byDate);
    if (!nodes.length) throw new Error(EMPTY_TIMELINE_ERROR);
    const formattedNodes = nodes.map((node)=>{
        const start = formatDate(node.data.date, locale);
        const end = formatDate(node.data.otherDate, locale);
        const date = end && end !== start ? `${start} - ${end}` : start;
        const documents = (node.data.documents ?? []).map((doc)=>doc.title).join(", ");
        const persons = (node.data.persons ?? []).map((person)=>person.name).join(", ");
        return [
            cleanHtml(node.data.label),
            cleanHtml(node.data.description),
            date,
            documents,
            persons
        ];
    });
    await Word.run(async (context)=>{
        const newTable = context.document.body.insertTable(formattedNodes.length + 1, headers.length, Word.InsertLocation.end, [
            headers,
            ...formattedNodes
        ]);
        newTable.select();
        newTable.style = "Normal";
        await context.sync();
    });
};
